import { render, staticRenderFns } from "./PrivacyStatementModal.vue?vue&type=template&id=c37f3fb2&scoped=true&"
import script from "./PrivacyStatementModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyStatementModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyStatementModal.vue?vue&type=style&index=0&id=c37f3fb2&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37f3fb2",
  null
  
)

export default component.exports